export enum UserRole {
  SUPER_USER = "SUPER",
  ADMIN_USER = "ADMIN",
  COLABORATOR_USER = "COLABORATOR",
  TEACHER_USER = "TEACHER",
  STUDENT_USER = "STUDENT",
  ADMIN = "ADMIN",
}
